import { ModalHeader as _ModalHeader, ModalHeaderProps as _ModalHeaderProps } from "reactstrap";

    export const ModalHeader = _ModalHeader;
    export type ModalHeaderProps = _ModalHeaderProps;
    